export default "__VITE_PUBLIC_ASSET__e6eeb450__"